const MOBILE_TEXT = 'mobile'
const TABLET_TEXT = 'tablet'
const LAPTOP_TEXT = 'laptop'
const DESKTOP_TEXT = 'desktop'
export default {
  actions: {
    actionResolution: (context, val) => context.commit('mutationSetResolution', val),
    actionShowAsideMenuMobile: (context, bool = false) => context.commit('mutationAsideMenuMobile', bool),
  },
  mutations: {
    mutationSetResolution: (state, val) => state.resolution = val,
    mutationAsideMenuMobile: (state, bool) => state.aside_menu_mobile = bool,
  },
  state: {
    resolution: window.innerWidth || 1024,
    aside_menu_mobile: false,
    breakpoints: {
      576: MOBILE_TEXT,
      1024: TABLET_TEXT,
      1440: LAPTOP_TEXT,
    }
  },
  getters: {
    getResolution: state => state.resolution,
    getCurrentDevice: state => {
      for (let breakpoint of Object.keys(state.breakpoints)) {
        if (state.resolution <= breakpoint) {
          return state.breakpoints[breakpoint]
        }
      }
      return DESKTOP_TEXT
    },
    getIsMobile: (state, getters) => getters.getCurrentDevice === MOBILE_TEXT,
    getIsTablet: (state, getters) => getters.getCurrentDevice === TABLET_TEXT,
    getAsideMenuMobile: state => state.aside_menu_mobile
  }
}
